import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { Badge } from '../../../atoms/badge';
import type { AvatarListBlock, BadgeVariant } from '../chat-content';

export function AvatarListBlockRenderer({ block }: { block: AvatarListBlock }) {
  return (
    <div className="w-full space-y-1.5">
      {block.heading && (
        <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide px-1 mb-2">
          {block.heading}
        </p>
      )}
      <div className="rounded-lg border border-border bg-card overflow-hidden divide-y divide-border">
        {block.items.map((item, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static list with no reorder
          <div key={i} className="flex items-center gap-3 px-4 py-3">
            {/* Avatar */}
            <AvatarPrimitive.Root className="relative flex size-8 shrink-0 overflow-hidden rounded-full">
              {item.avatarUrl && (
                <AvatarPrimitive.Image
                  src={item.avatarUrl}
                  alt={item.title}
                  className="aspect-square size-full object-cover"
                />
              )}
              <AvatarPrimitive.Fallback className="flex size-full items-center justify-center rounded-full bg-muted text-xs font-medium text-muted-foreground">
                {item.avatarText ?? item.title.slice(0, 2).toUpperCase()}
              </AvatarPrimitive.Fallback>
            </AvatarPrimitive.Root>

            {/* Text */}
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-foreground truncate">{item.title}</p>
              {item.description && (
                <p className="text-xs text-muted-foreground truncate">{item.description}</p>
              )}
            </div>

            {/* Right side */}
            <div className="flex items-center gap-2 shrink-0">
              {item.meta && <span className="text-xs text-muted-foreground">{item.meta}</span>}
              {item.badge && (
                <Badge
                  variant={(item.badge.variant ?? 'secondary') as BadgeVariant}
                  appearance="soft"
                  className="text-xs"
                >
                  {item.badge.label}
                </Badge>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
